import mori from 'mori';

/**
 * Get active columns (distributions) then reduce them down into:
 *  > header group
 *  > column
 *  > headergroup | column
 * @param  {[type]} distributions [description]
 * @return {[type]}               [description]
 */
export default function getDistributions(distributions) {
  return mori.flatten(mori.map(
    (item) => mori.isVector(item) ?
      mori.set([mori.first(item), mori.last(item)]) :
      item,
    mori.distinct(mori.reduce(
      (acc, curr) => mori.get(curr, 0) !== null ?
        mori.conj(mori.conj(
            mori.conj(acc, mori.get(curr, 0),
            mori.get(curr, 1)
          ),
          mori.conj(curr)
        )) :
        mori.conj(acc, mori.get(curr, 1)),
      mori.vector(),
      mori.reduce(
        (acc1, curr1) => mori.count(curr1) > 2 ?
          mori.conj(
            acc1,
            mori.vector(mori.first(curr1), mori.first(mori.rest(curr1)))
          ) :
          mori.conj(acc1, mori.vector(null, mori.first(curr1))),
        mori.vector(),
        distributions
      )
    ))
  ));
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/getFootnotes/getDistributions.js